import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import UIMessageProvider from '../../../components/common/UIMessageProvider';
import { IconType } from 'react-icons';
import { FaNewspaper, FaList, FaUserTie, FaPenFancy, FaTachometerAlt } from '../../../utils/iconUtils';

type Tab = {
  id: string;
  label: string;
  icon: IconType;
  path: string;
  description?: string;
  end?: boolean;
};

const NewsLayout: React.FC = () => {
  const location = useLocation();

  const tabs: Tab[] = [
    { id: 'dashboard', label: 'Dashboard', icon: FaTachometerAlt, path: 'dashboard', description: 'News overview' },
    { id: 'news', label: 'News Management', icon: FaNewspaper, path: '.', description: 'Manage news items', end: true },
   
  
    // { id: 'NewsCards', label: 'News Cards', icon: FaPenFancy, path: 'news-cards', description: 'News cards management' }
  ];

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-xl shadow-soft p-3">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
          <div>
            <h1 className="text-lg font-semibold text-gray-800">
              News <span className="text-gray-500 text-sm mt-0.5">(Manage site news & announcements)</span>
            </h1>
          </div>
        </div>

        <div className="mt-3">
          <div className="flex gap-2 overflow-x-auto whitespace-nowrap py-1">
            {tabs.map((tab) => (
              <NavLink
                key={tab.id}
                to={tab.path}
                end={tab.end ?? false}
                className={({ isActive }) =>
                  `inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-all flex-shrink-0 ${
                    isActive
                      ? 'bg-primary-600 text-white shadow'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`
                }
              >
                <tab.icon className="h-4 w-4" />
                <div className="text-left">
                  <span className="font-medium text-sm leading-tight">{tab.label}</span>
                  <p className="text-xs opacity-70 hidden lg:block leading-tight">{tab.description}</p>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      <div className="min-h-[420px]">
        <UIMessageProvider>
          <Outlet />
        </UIMessageProvider>
      </div>
    </div>
  );
};

export default NewsLayout;
